var ee = Object.defineProperty;
var te = (r, t, e) => t in r ? ee(r, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : r[t] = e;
var l = (r, t, e) => (te(r, typeof t != "symbol" ? t + "" : t, e), e);
import { createStore as re } from "vuex";
import { IonPage as ie, IonContent as ne } from "@ionic/vue";
import { createI18n as oe } from "vue-i18n";
import { resolveComponent as U, openBlock as I, createBlock as se, withCtx as R, createVNode as ae, createElementVNode as p, withDirectives as z, vModelText as ce, vModelDynamic as le, createElementBlock as M, normalizeStyle as ue, toDisplayString as de } from "vue";
class Z {
  constructor(t, e, i, n) {
    l(this, "baseUrl");
    l(this, "companyCode");
    l(this, "router");
    l(this, "axios");
    l(this, "loginPath");
    l(this, "afterLoginPath");
    l(this, "overwriteLoginProcess");
    l(this, "overwriteLogoutProcess");
    this.companyCode = t, this.router = e, this.axios = i, n ? (this.baseUrl = n.baseUrl ? n.baseUrl : "https://localhost:8080", this.loginPath = n.loginPath ? n.loginPath : "/login-page", this.afterLoginPath = n.afterLoginPath ? n.afterLoginPath : "/", this.overwriteLoginProcess = n.overwriteLoginProcess ? n.overwriteLoginProcess : null, this.overwriteLogoutProcess = n.overwriteLogoutProcess ? n.overwriteLogoutProcess : null) : (this.baseUrl = "https://localhost:8080", this.loginPath = "/login-page", this.afterLoginPath = "/", this.overwriteLoginProcess = null, this.overwriteLogoutProcess = null);
  }
}
const h = re({
  state: {
    authLibConfig: Z,
    locale: localStorage.getItem("locale") || window.navigator.language.slice(0, 2)
  },
  mutations: {
    setAuthLibConfig(r, t) {
      r.authLibConfig = t;
    },
    setLocale(r, t) {
      r.locale = t;
    }
  },
  getters: {
    authLibConfig: (r) => r.authLibConfig,
    locale: (r) => r.locale
  }
});
var P = function(r, t) {
  return P = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, i) {
    e.__proto__ = i;
  } || function(e, i) {
    for (var n in i)
      Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n]);
  }, P(r, t);
};
function m(r, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  P(r, t);
  function e() {
    this.constructor = r;
  }
  r.prototype = t === null ? Object.create(t) : (e.prototype = t.prototype, new e());
}
function _(r) {
  var t = typeof Symbol == "function" && Symbol.iterator, e = t && r[t], i = 0;
  if (e)
    return e.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && i >= r.length && (r = void 0), { value: r && r[i++], done: !r };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function w(r, t) {
  var e = typeof Symbol == "function" && r[Symbol.iterator];
  if (!e)
    return r;
  var i = e.call(r), n, o = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(n = i.next()).done; )
      o.push(n.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      n && !n.done && (e = i.return) && e.call(i);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return o;
}
function T(r, t, e) {
  if (e || arguments.length === 2)
    for (var i = 0, n = t.length, o; i < n; i++)
      (o || !(i in t)) && (o || (o = Array.prototype.slice.call(t, 0, i)), o[i] = t[i]);
  return r.concat(o || Array.prototype.slice.call(t));
}
function g(r) {
  return typeof r == "function";
}
function W(r) {
  var t = function(i) {
    Error.call(i), i.stack = new Error().stack;
  }, e = r(t);
  return e.prototype = Object.create(Error.prototype), e.prototype.constructor = e, e;
}
var x = W(function(r) {
  return function(e) {
    r(this), this.message = e ? e.length + ` errors occurred during unsubscription:
` + e.map(function(i, n) {
      return n + 1 + ") " + i.toString();
    }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = e;
  };
});
function O(r, t) {
  if (r) {
    var e = r.indexOf(t);
    0 <= e && r.splice(e, 1);
  }
}
var E = function() {
  function r(t) {
    this.initialTeardown = t, this.closed = !1, this._parentage = null, this._finalizers = null;
  }
  return r.prototype.unsubscribe = function() {
    var t, e, i, n, o;
    if (!this.closed) {
      this.closed = !0;
      var s = this._parentage;
      if (s)
        if (this._parentage = null, Array.isArray(s))
          try {
            for (var a = _(s), c = a.next(); !c.done; c = a.next()) {
              var C = c.value;
              C.remove(this);
            }
          } catch (d) {
            t = { error: d };
          } finally {
            try {
              c && !c.done && (e = a.return) && e.call(a);
            } finally {
              if (t)
                throw t.error;
            }
          }
        else
          s.remove(this);
      var D = this.initialTeardown;
      if (g(D))
        try {
          D();
        } catch (d) {
          o = d instanceof x ? d.errors : [d];
        }
      var k = this._finalizers;
      if (k) {
        this._finalizers = null;
        try {
          for (var b = _(k), f = b.next(); !f.done; f = b.next()) {
            var $ = f.value;
            try {
              j($);
            } catch (d) {
              o = o ?? [], d instanceof x ? o = T(T([], w(o)), w(d.errors)) : o.push(d);
            }
          }
        } catch (d) {
          i = { error: d };
        } finally {
          try {
            f && !f.done && (n = b.return) && n.call(b);
          } finally {
            if (i)
              throw i.error;
          }
        }
      }
      if (o)
        throw new x(o);
    }
  }, r.prototype.add = function(t) {
    var e;
    if (t && t !== this)
      if (this.closed)
        j(t);
      else {
        if (t instanceof r) {
          if (t.closed || t._hasParent(this))
            return;
          t._addParent(this);
        }
        (this._finalizers = (e = this._finalizers) !== null && e !== void 0 ? e : []).push(t);
      }
  }, r.prototype._hasParent = function(t) {
    var e = this._parentage;
    return e === t || Array.isArray(e) && e.includes(t);
  }, r.prototype._addParent = function(t) {
    var e = this._parentage;
    this._parentage = Array.isArray(e) ? (e.push(t), e) : e ? [e, t] : t;
  }, r.prototype._removeParent = function(t) {
    var e = this._parentage;
    e === t ? this._parentage = null : Array.isArray(e) && O(e, t);
  }, r.prototype.remove = function(t) {
    var e = this._finalizers;
    e && O(e, t), t instanceof r && t._removeParent(this);
  }, r.EMPTY = function() {
    var t = new r();
    return t.closed = !0, t;
  }(), r;
}(), Y = E.EMPTY;
function J(r) {
  return r instanceof E || r && "closed" in r && g(r.remove) && g(r.add) && g(r.unsubscribe);
}
function j(r) {
  g(r) ? r() : r.unsubscribe();
}
var K = {
  onUnhandledError: null,
  onStoppedNotification: null,
  Promise: void 0,
  useDeprecatedSynchronousErrorHandling: !1,
  useDeprecatedNextContext: !1
}, N = {
  setTimeout: function(r, t) {
    for (var e = [], i = 2; i < arguments.length; i++)
      e[i - 2] = arguments[i];
    var n = N.delegate;
    return n != null && n.setTimeout ? n.setTimeout.apply(n, T([r, t], w(e))) : setTimeout.apply(void 0, T([r, t], w(e)));
  },
  clearTimeout: function(r) {
    var t = N.delegate;
    return ((t == null ? void 0 : t.clearTimeout) || clearTimeout)(r);
  },
  delegate: void 0
};
function pe(r) {
  N.setTimeout(function() {
    throw r;
  });
}
function F() {
}
function y(r) {
  r();
}
var X = function(r) {
  m(t, r);
  function t(e) {
    var i = r.call(this) || this;
    return i.isStopped = !1, e ? (i.destination = e, J(e) && e.add(i)) : i.destination = ve, i;
  }
  return t.create = function(e, i, n) {
    return new L(e, i, n);
  }, t.prototype.next = function(e) {
    this.isStopped || this._next(e);
  }, t.prototype.error = function(e) {
    this.isStopped || (this.isStopped = !0, this._error(e));
  }, t.prototype.complete = function() {
    this.isStopped || (this.isStopped = !0, this._complete());
  }, t.prototype.unsubscribe = function() {
    this.closed || (this.isStopped = !0, r.prototype.unsubscribe.call(this), this.destination = null);
  }, t.prototype._next = function(e) {
    this.destination.next(e);
  }, t.prototype._error = function(e) {
    try {
      this.destination.error(e);
    } finally {
      this.unsubscribe();
    }
  }, t.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  }, t;
}(E), he = Function.prototype.bind;
function A(r, t) {
  return he.call(r, t);
}
var ge = function() {
  function r(t) {
    this.partialObserver = t;
  }
  return r.prototype.next = function(t) {
    var e = this.partialObserver;
    if (e.next)
      try {
        e.next(t);
      } catch (i) {
        S(i);
      }
  }, r.prototype.error = function(t) {
    var e = this.partialObserver;
    if (e.error)
      try {
        e.error(t);
      } catch (i) {
        S(i);
      }
    else
      S(t);
  }, r.prototype.complete = function() {
    var t = this.partialObserver;
    if (t.complete)
      try {
        t.complete();
      } catch (e) {
        S(e);
      }
  }, r;
}(), L = function(r) {
  m(t, r);
  function t(e, i, n) {
    var o = r.call(this) || this, s;
    if (g(e) || !e)
      s = {
        next: e ?? void 0,
        error: i ?? void 0,
        complete: n ?? void 0
      };
    else {
      var a;
      o && K.useDeprecatedNextContext ? (a = Object.create(e), a.unsubscribe = function() {
        return o.unsubscribe();
      }, s = {
        next: e.next && A(e.next, a),
        error: e.error && A(e.error, a),
        complete: e.complete && A(e.complete, a)
      }) : s = e;
    }
    return o.destination = new ge(s), o;
  }
  return t;
}(X);
function S(r) {
  pe(r);
}
function fe(r) {
  throw r;
}
var ve = {
  closed: !0,
  next: F,
  error: fe,
  complete: F
}, me = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
function be(r) {
  return r;
}
function Se(r) {
  return r.length === 0 ? be : r.length === 1 ? r[0] : function(e) {
    return r.reduce(function(i, n) {
      return n(i);
    }, e);
  };
}
var G = function() {
  function r(t) {
    t && (this._subscribe = t);
  }
  return r.prototype.lift = function(t) {
    var e = new r();
    return e.source = this, e.operator = t, e;
  }, r.prototype.subscribe = function(t, e, i) {
    var n = this, o = we(t) ? t : new L(t, e, i);
    return y(function() {
      var s = n, a = s.operator, c = s.source;
      o.add(a ? a.call(o, c) : c ? n._subscribe(o) : n._trySubscribe(o));
    }), o;
  }, r.prototype._trySubscribe = function(t) {
    try {
      return this._subscribe(t);
    } catch (e) {
      t.error(e);
    }
  }, r.prototype.forEach = function(t, e) {
    var i = this;
    return e = q(e), new e(function(n, o) {
      var s = new L({
        next: function(a) {
          try {
            t(a);
          } catch (c) {
            o(c), s.unsubscribe();
          }
        },
        error: o,
        complete: n
      });
      i.subscribe(s);
    });
  }, r.prototype._subscribe = function(t) {
    var e;
    return (e = this.source) === null || e === void 0 ? void 0 : e.subscribe(t);
  }, r.prototype[me] = function() {
    return this;
  }, r.prototype.pipe = function() {
    for (var t = [], e = 0; e < arguments.length; e++)
      t[e] = arguments[e];
    return Se(t)(this);
  }, r.prototype.toPromise = function(t) {
    var e = this;
    return t = q(t), new t(function(i, n) {
      var o;
      e.subscribe(function(s) {
        return o = s;
      }, function(s) {
        return n(s);
      }, function() {
        return i(o);
      });
    });
  }, r.create = function(t) {
    return new r(t);
  }, r;
}();
function q(r) {
  var t;
  return (t = r ?? K.Promise) !== null && t !== void 0 ? t : Promise;
}
function ye(r) {
  return r && g(r.next) && g(r.error) && g(r.complete);
}
function we(r) {
  return r && r instanceof X || ye(r) && J(r);
}
var Te = W(function(r) {
  return function() {
    r(this), this.name = "ObjectUnsubscribedError", this.message = "object unsubscribed";
  };
}), Q = function(r) {
  m(t, r);
  function t() {
    var e = r.call(this) || this;
    return e.closed = !1, e.currentObservers = null, e.observers = [], e.isStopped = !1, e.hasError = !1, e.thrownError = null, e;
  }
  return t.prototype.lift = function(e) {
    var i = new V(this, this);
    return i.operator = e, i;
  }, t.prototype._throwIfClosed = function() {
    if (this.closed)
      throw new Te();
  }, t.prototype.next = function(e) {
    var i = this;
    y(function() {
      var n, o;
      if (i._throwIfClosed(), !i.isStopped) {
        i.currentObservers || (i.currentObservers = Array.from(i.observers));
        try {
          for (var s = _(i.currentObservers), a = s.next(); !a.done; a = s.next()) {
            var c = a.value;
            c.next(e);
          }
        } catch (C) {
          n = { error: C };
        } finally {
          try {
            a && !a.done && (o = s.return) && o.call(s);
          } finally {
            if (n)
              throw n.error;
          }
        }
      }
    });
  }, t.prototype.error = function(e) {
    var i = this;
    y(function() {
      if (i._throwIfClosed(), !i.isStopped) {
        i.hasError = i.isStopped = !0, i.thrownError = e;
        for (var n = i.observers; n.length; )
          n.shift().error(e);
      }
    });
  }, t.prototype.complete = function() {
    var e = this;
    y(function() {
      if (e._throwIfClosed(), !e.isStopped) {
        e.isStopped = !0;
        for (var i = e.observers; i.length; )
          i.shift().complete();
      }
    });
  }, t.prototype.unsubscribe = function() {
    this.isStopped = this.closed = !0, this.observers = this.currentObservers = null;
  }, Object.defineProperty(t.prototype, "observed", {
    get: function() {
      var e;
      return ((e = this.observers) === null || e === void 0 ? void 0 : e.length) > 0;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype._trySubscribe = function(e) {
    return this._throwIfClosed(), r.prototype._trySubscribe.call(this, e);
  }, t.prototype._subscribe = function(e) {
    return this._throwIfClosed(), this._checkFinalizedStatuses(e), this._innerSubscribe(e);
  }, t.prototype._innerSubscribe = function(e) {
    var i = this, n = this, o = n.hasError, s = n.isStopped, a = n.observers;
    return o || s ? Y : (this.currentObservers = null, a.push(e), new E(function() {
      i.currentObservers = null, O(a, e);
    }));
  }, t.prototype._checkFinalizedStatuses = function(e) {
    var i = this, n = i.hasError, o = i.thrownError, s = i.isStopped;
    n ? e.error(o) : s && e.complete();
  }, t.prototype.asObservable = function() {
    var e = new G();
    return e.source = this, e;
  }, t.create = function(e, i) {
    return new V(e, i);
  }, t;
}(G), V = function(r) {
  m(t, r);
  function t(e, i) {
    var n = r.call(this) || this;
    return n.destination = e, n.source = i, n;
  }
  return t.prototype.next = function(e) {
    var i, n;
    (n = (i = this.destination) === null || i === void 0 ? void 0 : i.next) === null || n === void 0 || n.call(i, e);
  }, t.prototype.error = function(e) {
    var i, n;
    (n = (i = this.destination) === null || i === void 0 ? void 0 : i.error) === null || n === void 0 || n.call(i, e);
  }, t.prototype.complete = function() {
    var e, i;
    (i = (e = this.destination) === null || e === void 0 ? void 0 : e.complete) === null || i === void 0 || i.call(e);
  }, t.prototype._subscribe = function(e) {
    var i, n;
    return (n = (i = this.source) === null || i === void 0 ? void 0 : i.subscribe(e)) !== null && n !== void 0 ? n : Y;
  }, t;
}(Q), Ee = function(r) {
  m(t, r);
  function t(e) {
    var i = r.call(this) || this;
    return i._value = e, i;
  }
  return Object.defineProperty(t.prototype, "value", {
    get: function() {
      return this.getValue();
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype._subscribe = function(e) {
    var i = r.prototype._subscribe.call(this, e);
    return !i.closed && e.next(this._value), i;
  }, t.prototype.getValue = function() {
    var e = this, i = e.hasError, n = e.thrownError, o = e._value;
    if (i)
      throw n;
    return this._throwIfClosed(), o;
  }, t.prototype.next = function(e) {
    r.prototype.next.call(this, this._value = e);
  }, t;
}(Q);
class B {
  constructor(t) {
    l(this, "idUsuari");
    l(this, "nom");
    l(this, "cognoms");
    l(this, "email");
    l(this, "llistaClients");
    this.idUsuari = t.idUsuari, this.nom = t.nom, this.cognoms = t.cognoms, this.email = t.email, this.llistaClients = t.llistaClients;
  }
}
class v extends Error {
}
v.prototype.name = "InvalidTokenError";
function Ce(r) {
  return decodeURIComponent(atob(r).replace(/(.)/g, (t, e) => {
    let i = e.charCodeAt(0).toString(16).toUpperCase();
    return i.length < 2 && (i = "0" + i), "%" + i;
  }));
}
function Ie(r) {
  let t = r.replace(/-/g, "+").replace(/_/g, "/");
  switch (t.length % 4) {
    case 0:
      break;
    case 2:
      t += "==";
      break;
    case 3:
      t += "=";
      break;
    default:
      throw new Error("base64 string is not of the correct length");
  }
  try {
    return Ce(t);
  } catch {
    return atob(t);
  }
}
function xe(r, t) {
  if (typeof r != "string")
    throw new v("Invalid token specified: must be a string");
  t || (t = {});
  const e = t.header === !0 ? 0 : 1, i = r.split(".")[e];
  if (typeof i != "string")
    throw new v(`Invalid token specified: missing part #${e + 1}`);
  let n;
  try {
    n = Ie(i);
  } catch (o) {
    throw new v(`Invalid token specified: invalid base64 for part #${e + 1} (${o.message})`);
  }
  try {
    return JSON.parse(n);
  } catch (o) {
    throw new v(`Invalid token specified: invalid json for part #${e + 1} (${o.message})`);
  }
}
class u {
  static async login(t, e) {
    const i = h.getters.authLibConfig, n = await i.axios.post(
      i.baseUrl + "/apiV2/login/loginAndRegister",
      {
        codiEmpresa: i.companyCode,
        usuari: t,
        contrasenya: e
      }
    );
    localStorage.setItem("auth-lib-token", n.data), await this.getUsuari(this.getToken());
  }
  static getToken() {
    return localStorage.getItem("auth-lib-token");
  }
  static logOut() {
    localStorage.removeItem("auth-lib-token"), localStorage.removeItem("auth-lib-user"), this.user = void 0, this.authStateSubject.next(!1);
  }
  static loginProcessCompleted() {
    this.authStateSubject.next(!0);
  }
  static authenticationObserver() {
    return this.authStateSubject.asObservable();
  }
  static async getUsuari(t) {
    const e = h.getters.authLibConfig, i = xe(t);
    h.getters.authLibConfig.axios.get(e.baseUrl + `/apiV2/usuaris?filter=idUsuari:${i.userId}`).then(async (n) => {
      this.user = new B(n.data[0]), console.log("🚀 ~ AuthService ~ .then ~ this.user:", this.user);
      let o = [];
      for (let s = 0; s < this.user.llistaClients.length; s++) {
        let a = this.user.llistaClients[s].codiClient;
        o.push(a);
      }
      this.user.llistaClients = o, localStorage.setItem("auth-lib-user", JSON.stringify(this.user)), this.loginProcessCompleted();
    });
  }
  static getUser() {
    if (!this.user) {
      const t = localStorage.getItem("auth-lib-user");
      t && (console.log("🚀 ~ AuthService ~ getUser ~ storedUser:", t), this.user = new B(JSON.parse(t)), console.log("🚀 ~ AuthService ~ getUser ~ this.user:", this.user));
    }
    return console.log("🚀 ~ AuthService ~ getUser ~ this.user:", this.user), this.user;
  }
}
l(u, "authStateSubject", new Ee(null)), l(u, "user");
const Ae = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><circle cx='256' cy='256' r='64'/><path d='M490.84 238.6c-26.46-40.92-60.79-75.68-99.27-100.53C349 110.55 302 96 255.66 96c-42.52 0-84.33 12.15-124.27 36.11-40.73 24.43-77.63 60.12-109.68 106.07a31.92 31.92 0 00-.64 35.54c26.41 41.33 60.4 76.14 98.28 100.65C162 402 207.9 416 255.66 416c46.71 0 93.81-14.43 136.2-41.72 38.46-24.77 72.72-59.66 99.08-100.92a32.2 32.2 0 00-.1-34.76zM256 352a96 96 0 1196-96 96.11 96.11 0 01-96 96z'/></svg>", Pe = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><path d='M432 448a15.92 15.92 0 01-11.31-4.69l-352-352a16 16 0 0122.62-22.62l352 352A16 16 0 01432 448zM248 315.85l-51.79-51.79a2 2 0 00-3.39 1.69 64.11 64.11 0 0053.49 53.49 2 2 0 001.69-3.39zM264 196.15L315.87 248a2 2 0 003.4-1.69 64.13 64.13 0 00-53.55-53.55 2 2 0 00-1.72 3.39z'/><path d='M491 273.36a32.2 32.2 0 00-.1-34.76c-26.46-40.92-60.79-75.68-99.27-100.53C349 110.55 302 96 255.68 96a226.54 226.54 0 00-71.82 11.79 4 4 0 00-1.56 6.63l47.24 47.24a4 4 0 003.82 1.05 96 96 0 01116 116 4 4 0 001.05 3.81l67.95 68a4 4 0 005.4.24 343.81 343.81 0 0067.24-77.4zM256 352a96 96 0 01-93.3-118.63 4 4 0 00-1.05-3.81l-66.84-66.87a4 4 0 00-5.41-.23c-24.39 20.81-47 46.13-67.67 75.72a31.92 31.92 0 00-.64 35.54c26.41 41.33 60.39 76.14 98.28 100.65C162.06 402 207.92 416 255.68 416a238.22 238.22 0 0072.64-11.55 4 4 0 001.61-6.64l-47.47-47.46a4 4 0 00-3.81-1.05A96 96 0 01256 352z'/></svg>", _e = {
  login: {
    userName: "Nom d'Usuari",
    password: "Contrasenya",
    login: "INICIAR SESSIÓ"
  }
}, Oe = {
  login: {
    userName: "Nombre de Usuario",
    password: "Contraseña",
    login: "INICIAR SESSION"
  },
  navbar: {
    home: "Principal",
    contracts: "Contratos",
    settings: "Configuración",
    info: "Ayuda"
  },
  header: {
    home: "PRINCIPAL",
    contracts: "CONTRATOS",
    settings: "CONFIGURACIÓN",
    info: "AYUDA",
    contract: "CONTRATO",
    addService: "AÑADIR SERVICIO",
    service: "SERVICIO"
  },
  home: {
    hello: "Hola"
  },
  contracts: {
    active: "Activos",
    suspended: "Bajas",
    services: "Servicios",
    noSuspendedContracts: "No hay contratos de baja",
    noServices: "No hay servicios associados a este contrato"
  },
  settings: {
    user: "USUARIO",
    closeSession: "Cerrar Sessión",
    settings: "CONFIGURACIÓN",
    appLanguage: "Idioma de la aplicación",
    confirmationText: "Seguro que quieres cerrar tu sessión?"
  },
  info: {},
  addService: {
    addTitle: "Solicitar un Servicio",
    editTitle: "Servicio",
    entrance: "Entrada al camping",
    exit: "Salida del camping",
    doneText: "Hecho",
    cancelText: "Cancelar",
    transportDate: "Fecha del transporte",
    camping: "Camping",
    selectCamping: "-- Seleccionar --",
    parcel: "Parcela",
    selectParcel: "Selecciona la parcela",
    save: "Guardar",
    toastMessage: "Tienes que llenar todos los campos para guardar!",
    requestService: "Solicitar el servicio",
    serviceSummary: "Resumen servicio",
    total: "Total",
    serviceConfirm: "Estàs seguro de que quieres solicitar este servicio?",
    loading: "Pidiendo servicio..."
  },
  service: {
    pending: "Pendiente",
    completed: "Finalizado",
    requestCompleted: "La petición de servicio se ha realizado correctamente"
  },
  contract: {
    entrance: "Entrada",
    exit: "Salida",
    registration: "Matrícula",
    initialDate: "Fecha inicial",
    finalDate: "Fecha final",
    zone: "Zona",
    parkType: "Tipo de parking",
    pendingServices: "Servicios Pendientes"
  },
  interceptors: {
    noAuthorized: "Usuario no autorizado"
  }
}, Ne = {
  login: {
    userName: "User Name",
    password: "Password",
    login: "LOG-IN"
  },
  navbar: {
    home: "Home",
    contracts: "Contracts",
    settings: "Settings",
    info: "Info"
  },
  header: {
    home: "HOME",
    contracts: "CONTRACTS",
    settings: "SETTINGS",
    info: "INFO",
    contract: "CONTRACT",
    addService: "ADD SERVICE",
    service: "SERVICE"
  },
  home: {
    hello: "Hi"
  },
  contracts: {
    active: "Active",
    suspended: "Suspended",
    services: "Services",
    noSuspendedContracts: "There's not suspended contracts",
    noServices: "There's not services associates in this contract"
  },
  settings: {
    user: "USER",
    closeSession: "Log Out",
    settings: "SETTINGS",
    appLanguage: "App Language",
    confirmationText: "Are you sure you want to log out?"
  },
  info: {},
  addService: {
    addTitle: "Request a Service",
    editTitle: "Service",
    entrance: "Camping Entrance",
    exit: "Camping Exit",
    doneText: "Done",
    cancelText: "Cancel",
    transportDate: "Transport Date",
    camping: "Camping",
    selectCamping: "-- Select --",
    parcel: "Parcel",
    selectParcel: "Select the parcel",
    save: "Save",
    toastMessage: "You must field all the fields to save!",
    requestService: "Request this service",
    serviceSummary: "Service summary",
    total: "Total",
    serviceConfirm: "Are you sure you want to request this service?",
    loading: "Requesting service..."
  },
  service: {
    pending: "Pending",
    completed: "Completed",
    requestCompleted: "The service has been requested correctly"
  },
  contract: {
    entrance: "Entrance",
    exit: "Exit",
    registration: "Registration",
    initialDate: "Start Date",
    finalDate: "End Date",
    zone: "Zone",
    parkType: "Parking Type",
    pendingServices: "Pending Services"
  },
  interceptors: {
    noAuthorized: "Unauthorized user"
  }
}, Le = {
  login: {
    userName: "Nom d'utilisateur",
    password: "Mot de passe",
    login: "CONNEXION"
  },
  navbar: {
    home: "Accueil",
    contracts: "Contrats",
    settings: "Paramètres",
    info: "Aide"
  },
  header: {
    home: "ACCUEIL",
    contracts: "CONTRATS",
    settings: "PARAMÈTRES",
    info: "AIDE",
    contract: "CONTRAT",
    addService: "AJOUTER UN SERVICE",
    service: "SERVICE"
  },
  home: {
    hello: "Bonjour"
  },
  contracts: {
    active: "Actifs",
    suspended: "Suspendus",
    services: "Services",
    noSuspendedContracts: "Il n'y a pas de contrats suspendus",
    noServices: "Il n'y a pas de services associés à ce contrat"
  },
  settings: {
    user: "UTILISATEUR",
    closeSession: "Fermer la session",
    settings: "PARAMÈTRES",
    appLanguage: "Langue de l'application",
    confirmationText: "Êtes-vous sûr de vouloir vous déconnecter de votre session?"
  },
  info: {},
  addService: {
    addTitle: "Demander un Service",
    editTitle: "Service",
    entrance: "Entrée du camping",
    exit: "Sortie du camping",
    doneText: "Fait",
    cancelText: "Annuler",
    transportDate: "Date du transport",
    camping: "Camping",
    selectCamping: "-- Sélectionner --",
    parcel: "Parcelle",
    selectParcel: "Sélectionnez la parcelle",
    save: "Enregistrer",
    toastMessage: "Vous devez remplir tous les champs pour enregistrer!",
    requestService: "Demander ce service",
    serviceSummary: "Résumé du service",
    total: "Total",
    serviceConfirm: "Êtes-vous sûr de vouloir demander ce service ?",
    loading: "Demande de service..."
  },
  service: {
    pending: "En Attente",
    completed: "Terminé",
    requestCompleted: "Le service a été demandé correctement"
  },
  contract: {
    entrance: "Entrée",
    exit: "Sortie",
    registration: "Inscription",
    initialDate: "Date de début",
    finalDate: "Date de fin",
    zone: "Zone",
    parkType: "Type de parking",
    pendingServices: "Services en Attente"
  },
  interceptors: {
    noAuthorized: "Utilisateur non autorisé"
  }
}, De = {
  login: {
    userName: "Nome utente",
    password: "Password",
    login: "ACCEDI"
  },
  navbar: {
    home: "Principale",
    contracts: "Contratti",
    settings: "Impostazioni",
    info: "Guida"
  },
  header: {
    home: "PRINCIPALE",
    contracts: "CONTRATTI",
    settings: "IMPOSTAZIONI",
    info: "GUIDA",
    contract: "CONTRATTO",
    addService: "AGGIUNGI SERVIZIO",
    service: "SERVIZIO"
  },
  home: {
    hello: "Ciao"
  },
  contracts: {
    active: "Attivi",
    suspended: "Sospesi",
    services: "Servizi",
    noSuspendedContracts: "Non ci sono contratti sospesi",
    noServices: "Non ci sono servizi associati a questo contratto"
  },
  settings: {
    user: "UTENTE",
    closeSession: "Chiudi Sessione",
    settings: "IMPOSTAZIONI",
    appLanguage: "Lingua dell'app",
    confirmationText: "Sei sicuro di voler uscire dalla tua sessione?"
  },
  info: {},
  addService: {
    addTitle: "Richiedi un Servizio",
    editTitle: "Servizio",
    entrance: "Entrata al campeggio",
    exit: "Uscita dal campeggio",
    doneText: "Fatto",
    cancelText: "Annulla",
    transportDate: "Data del trasporto",
    camping: "Campeggio",
    selectCamping: "-- Seleziona --",
    parcel: "Parcella",
    selectParcel: "Seleziona la parcella",
    save: "Salva",
    toastMessage: "Devi compilare tutti i campi per salvare!",
    requestService: "Richiedi questo servizio",
    serviceSummary: "Sommario del servizio",
    total: "Totale",
    serviceConfirm: "Sei sicuro di voler richiedere questo servizio?",
    loading: "Richiesta di servizio..."
  },
  service: {
    pending: "In Sospeso",
    completed: "Completato",
    requestCompleted: "Il servizio è stato richiesto correttamente"
  },
  contract: {
    entrance: "Entrata",
    exit: "Uscita",
    registration: "Registrazione",
    initialDate: "Data iniziale",
    finalDate: "Data finale",
    zone: "Zona",
    parkType: "Tipo di parcheggio",
    pendingServices: "Servizi in Sospeso"
  },
  interceptors: {
    noAuthorized: "Utente non autorizzato"
  }
}, ke = {
  login: {
    userName: "Benutzername",
    password: "Passwort",
    login: "ANMELDEN"
  },
  navbar: {
    home: "Startseite",
    contracts: "Verträge",
    settings: "Einstellungen",
    info: "Anleitung"
  },
  header: {
    home: "STARTSEITE",
    contracts: "VERTRÄGE",
    settings: "EINSTELLUNGEN",
    info: "ANLEITUNG",
    contract: "VERTRAG",
    addService: "DIENST HINZUFÜGEN",
    service: "DIENST"
  },
  home: {
    hello: "Hallo"
  },
  contracts: {
    active: "Aktiv",
    suspended: "Ausgesetzt",
    services: "Dienste",
    noSuspendedContracts: "Es gibt keine ausgesetzten Verträge",
    noServices: "Es gibt keine mit diesem Vertrag verbundenen Dienstleistungen"
  },
  settings: {
    user: "BENUTZER",
    closeSession: "Sitzung schließen",
    settings: "EINSTELLUNGEN",
    appLanguage: "App-Sprache",
    confirmationText: "Bist du sicher, dass du dich abmelden möchtest?"
  },
  info: {},
  addService: {
    addTitle: "Dienst beantragen",
    editTitle: "Dienst",
    entrance: "Eintritt ins Camping",
    exit: "Austritt aus dem Camping",
    doneText: "Fertig",
    cancelText: "Abbrechen",
    transportDate: "Transportdatum",
    camping: "Camping",
    selectCamping: "-- Auswählen --",
    parcel: "Grundstück",
    selectParcel: "Wählen Sie das Grundstück aus",
    save: "Speichern",
    toastMessage: "Sie müssen alle Felder ausfüllen, um zu speichern!",
    requestService: "Diese Dienstleistung anfordern",
    serviceSummary: "Dienstleistungsübersicht",
    total: "Gesamt",
    serviceConfirm: "Sind Sie sicher, dass Sie diese Dienstleistung anfordern möchten?",
    loading: "Service anfordern..."
  },
  service: {
    pending: "Ausstehend",
    completed: "Abgeschlossen",
    requestCompleted: "Der Service wurde korrekt angefordert"
  },
  contract: {
    entrance: "Eintritt",
    exit: "Austritt",
    registration: "Anmeldung",
    initialDate: "Startdatum",
    finalDate: "Enddatum",
    zone: "Zone",
    parkType: "Parktyp",
    pendingServices: "Ausstehende Dienste"
  },
  interceptors: {
    noAuthorized: "Nicht autorisierter Benutzer"
  }
}, Ue = {
  login: {
    userName: "Gebruikersnaam",
    password: "Wachtwoord",
    login: "INLOGGEN"
  },
  navbar: {
    home: "Startpagina",
    contracts: "Contracten",
    settings: "Instellingen",
    info: "Handleiding"
  },
  header: {
    home: "STARTPAGINA",
    contracts: "CONTRACTEN",
    settings: "INSTELLINGEN",
    info: "HANDLEIDING",
    contract: "CONTRACT",
    addService: "DIENST TOEVOEGEN",
    service: "DIENST"
  },
  home: {
    hello: "Hallo"
  },
  contracts: {
    active: "Actief",
    suspended: "Opgeschort",
    services: "Diensten",
    noSuspendedContracts: "Er zijn geen opgeschorte contracten",
    noServices: "Er zijn geen services geassocieerd met dit contract"
  },
  settings: {
    user: "GEBRUIKER",
    closeSession: "Sessie sluiten",
    settings: "INSTELLINGEN",
    appLanguage: "App-taal",
    confirmationText: "Weet je zeker dat je wilt uitloggen uit je sessie?"
  },
  info: {},
  addService: {
    addTitle: "Dienst aanvragen",
    editTitle: "Dienst",
    entrance: "Toegang tot de camping",
    exit: "Vertrek van de camping",
    doneText: "Gedaan",
    cancelText: "Annuleren",
    transportDate: "Transportdatum",
    camping: "Camping",
    selectCamping: "-- Selecteer --",
    parcel: "Perceel",
    selectParcel: "Selecteer het perceel",
    save: "Opslaan",
    toastMessage: "U moet alle velden invullen om op te slaan!",
    requestService: "Deze service aanvragen",
    serviceSummary: "Serviceoverzicht",
    total: "Totaal",
    serviceConfirm: "Weet u zeker dat u deze service wilt aanvragen?",
    loading: "Dienstverlening aanvragen..."
  },
  service: {
    pending: "In behandeling",
    completed: "Voltooid",
    requestCompleted: "De service is correct aangevraagd"
  },
  contract: {
    entrance: "Toegang",
    exit: "Vertrek",
    registration: "Registratie",
    initialDate: "Startdatum",
    finalDate: "Einddatum",
    zone: "Zone",
    parkType: "Soort parkeerplaats",
    pendingServices: "Diensten in behandeling"
  },
  interceptors: {
    noAuthorized: "Niet-geautoriseerde gebruiker"
  }
}, Re = oe({
  legacy: !1,
  globalInjection: !0,
  locale: h.state.locale,
  fallbackLocale: "en",
  messages: {
    ca: _e,
    es: Oe,
    en: Ne,
    fr: Le,
    it: De,
    de: ke,
    nl: Ue
  }
}), ze = {
  components: { IonPage: ie, IonContent: ne },
  name: "LoginPage",
  props: {
    buttonColor: { type: String, default: "grey" }
  },
  setup() {
    return {
      eye: Ae,
      eyeOff: Pe,
      i18n: Re
    };
  },
  data() {
    return {
      showPassword: !1,
      passwordType: "password",
      imgPath: "assets/logo.jpg",
      user: "",
      password: ""
    };
  },
  beforeMount() {
  },
  methods: {
    togglePassword: function() {
      this.showPassword = !this.showPassword, this.showPassword ? this.passwordType = "text" : this.passwordType = "password";
    },
    checkCredentials: async function() {
      await u.login(this.user, this.password);
    }
  }
}, Me = (r, t) => {
  const e = r.__vccOpts || r;
  for (const [i, n] of t)
    e[i] = n;
  return e;
}, je = { style: { height: "100%", background: "#FFFFFF", display: "flex", "justify-content": "center", "align-items": "center" } }, Fe = { style: { padding: "0 45px 100px 45px", "text-align": "center", width: "100%" } }, Ge = ["src"], qe = { style: { position: "relative", "max-width": "400px", margin: "auto" } }, Ve = ["placeholder"], Be = { style: { position: "relative" } }, He = ["type", "placeholder"], Ze = ["src"], We = ["src"];
function Ye(r, t, e, i, n, o) {
  const s = U("ion-content"), a = U("ion-page");
  return I(), se(a, null, {
    default: R(() => [
      ae(s, null, {
        default: R(() => [
          p("div", je, [
            p("div", Fe, [
              p("div", null, [
                p("img", {
                  style: { "margin-bottom": "75px" },
                  src: n.imgPath,
                  alt: "Logo",
                  height: "150px",
                  width: "auto"
                }, null, 8, Ge)
              ]),
              p("form", qe, [
                z(p("input", {
                  "onUpdate:modelValue": t[0] || (t[0] = (c) => n.user = c),
                  type: "text",
                  placeholder: i.i18n.global.t("login.userName"),
                  style: { "border-radius": "5px", "font-family": "'Roboto', sans-serif", outline: "0", background: "#f2f2f2", width: "100%", border: "0", margin: "0 0 15px", padding: "15px", "box-sizing": "border-box", "font-size": "14px", color: "black" }
                }, null, 8, Ve), [
                  [ce, n.user]
                ]),
                p("div", Be, [
                  z(p("input", {
                    "onUpdate:modelValue": t[1] || (t[1] = (c) => n.password = c),
                    type: n.passwordType,
                    placeholder: i.i18n.global.t("login.password"),
                    style: { "border-radius": "5px", "font-family": "'Roboto', sans-serif", outline: "0", background: "#f2f2f2", width: "100%", border: "0", margin: "0 0 75px", padding: "15px", "box-sizing": "border-box", "font-size": "14px", color: "black", "padding-right": "40px" }
                  }, null, 8, He), [
                    [le, n.password]
                  ]),
                  p("button", {
                    type: "button",
                    onClick: t[2] || (t[2] = (c) => o.togglePassword()),
                    style: { position: "absolute", right: "0", padding: "12px", "background-color": "transparent" }
                  }, [
                    n.showPassword ? (I(), M("img", {
                      key: 0,
                      src: i.eye,
                      alt: "eye",
                      width: "20px",
                      height: "auto"
                    }, null, 8, Ze)) : (I(), M("img", {
                      key: 1,
                      src: i.eyeOff,
                      alt: "eyeOff",
                      width: "20px",
                      height: "auto"
                    }, null, 8, We))
                  ])
                ]),
                p("button", {
                  type: "button",
                  onClick: t[3] || (t[3] = (c) => o.checkCredentials()),
                  style: ue([{ backgroundColor: e.buttonColor }, { "border-radius": "5px", "font-family": "'Roboto', sans-serif", "text-transform": "uppercase", outline: "0", width: "100%", border: "0", padding: "15px", color: "#FFFFFF", "font-size": "14px", cursor: "pointer" }])
                }, de(i.i18n.global.t("login.login")), 5)
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  });
}
const rt = /* @__PURE__ */ Me(ze, [["render", Ye]]);
function Je() {
  h.getters.authLibConfig.axios.interceptors.request.use((r) => {
    const t = u.getToken();
    return t && (r.headers.Authorization = `Bearer ${t}`), r;
  }, function(r) {
    return Promise.reject(r);
  }), h.getters.authLibConfig.axios.interceptors.response.use((r) => r, async function(r) {
    r.status === 401 && h.getters.authLibConfig.router.currentRoute.path !== h.getters.authLibConfig.loginPath && Ke.logOut();
  });
}
const H = {
  async initAuthLib(r, t, e, i) {
    h.commit("setAuthLibConfig", new Z(r, t, e, i)), this.initStorageListener(), this.initAuthServerObserver(t), this.initMiddleWare(t), Je(), u.getToken() && await u.getUsuari(u.getToken());
  },
  initStorageListener() {
    window.addEventListener("storage", (r) => {
      (r.key === "auth-lib-user" || r.key === "auth-lib-token") && u.logOut();
    });
  },
  initAuthServerObserver(r) {
    const t = h.getters.authLibConfig;
    u.authenticationObserver().subscribe(async (e) => {
      e != null && (e ? t.overwriteLoginProcess ? t.overwriteLoginProcess() : await r.push({ path: r.currentRoute.value.path == t.loginPath ? t.afterLoginPath : r.currentRoute.value.path, replace: !0 }) : t.overwriteLogoutProcess ? t.overwriteLogoutProcess() : await r.push({ path: t.loginPath, replace: !0 }));
    });
  },
  initMiddleWare(r) {
    function t(e, i, n) {
      const o = i[n];
      return o ? (...s) => {
        e.next(...s);
        const a = t(e, i, n + 1);
        o({ ...e, next: a });
      } : e.next;
    }
    r.beforeEach((e, i, n) => {
      if (e.meta.middleware) {
        const o = Array.isArray(e.meta.middleware) ? e.meta.middleware : [e.meta.middleware], s = {
          from: i,
          next: n,
          router: r,
          to: e
        }, a = t(s, o, 1);
        return o[0]({ ...s, next: a });
      }
      return n();
    });
  },
  async authLibMiddleware({ next: r }) {
    return !localStorage.getItem("auth-lib-token") || !localStorage.getItem("auth-lib-user") ? (u.logOut(), r({ name: "login-page" })) : r();
  }
}, Ke = {
  async initAuthLib(r, t, e, i) {
    await H.initAuthLib(r, t, e, i);
  },
  async authLibMiddleware({ next: r }) {
    await H.authLibMiddleware({ next: r });
  },
  login(r, t) {
    return u.login(r, t);
  },
  logOut() {
    u.logOut();
  },
  getUser() {
    return u.getUser();
  },
  getToken() {
    return u.getToken();
  }
};
export {
  Ke as AuthLib,
  rt as LoginPage
};
